import { FormControlLabel } from "@mui/material";

const RadioLabel = ({ ...props }) => {
  return (
    <FormControlLabel
      sx={{
        "& .MuiTypography-root": {
          fontSize: 14,
          letterSpacing: 0,
          lineHeight: "16px",
          color: "var(--secondary)",
        },
      }}
      {...props}
    />
  );
};

export default RadioLabel;
